export const GET_ALL_COUNTER_CONTRACTORS = "GET_ALL_COUNTER_CONTRACTORS"
export const CREATE_COUNTER_CONTRACTOR = "CREATE_COUNTER_CONTRACTOR"
export const UPDATE_COUNTER_CONTRACTOR = "UPDATE_COUNTER_CONTRACTOR"
export const DELETE_COUNTER_CONTRACTOR = "DELETE_COUNTER_CONTRACTOR"
export const SELECT_COUNTER_CONTRACTOR = "SELECT_COUNTER_CONTRACTOR"
